import { useCallback, useState } from 'react';
import type { RecentItem } from './types';

const STORAGE_KEY = 'command-palette-recent';
const MAX_ITEMS = 20;

function loadRecent(): RecentItem[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

interface UseRecentItemsReturn {
  recentItems: RecentItem[];
  addRecentItem: (item: Omit<RecentItem, 'visitedAt'>) => void;
}

export function useRecentItems(): UseRecentItemsReturn {
  const [items, setItems] = useState<RecentItem[]>(loadRecent);

  const addRecentItem = useCallback(
    (item: Omit<RecentItem, 'visitedAt'>) => {
      setItems((prev) => {
        const filtered = prev.filter((i) => i.id !== item.id);
        const updated = [
          { ...item, visitedAt: Date.now() },
          ...filtered,
        ].slice(0, MAX_ITEMS);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
        return updated;
      });
    },
    [],
  );

  return { recentItems: items, addRecentItem };
}
